<template>
  <div>
    <div class="header">
      <img class= "back" src="../../assets/previous.png" @click="$router.go(-1)">
      <div class="title">{{ title }}</div>
      <img class= "help" @click="isHelpShow=true" src="../../assets/help.png">
    </div>
    <div class="help-contaner">
      <transition name="shade">
        <div class="shade" @click="isHelpShow=false" v-if="isHelpShow" @touchmove="$event.preventDefault()"></div>
      </transition>
      <Help ref="help" class="wrapper" v-if="isHelpShow" @close="isHelpShow=false"></Help>
    </div>
  </div>
</template>
<script>
import Help from './help.vue';
export default {
  components: {
    Help
  },
  props: {
    title: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      isHelpShow: false
    }
  },
}
</script>
<style lang="stylus" scoped>
.header
    position relative
    z-index 3
    width 100%
    height .39rem 
    padding 0 .12rem 0 .15rem
    box-sizing border-box
    background linear-gradient(90deg,rgba(255,32,32,1) 0%,rgba(244,55,55,1) 100%)
    display flex
    justify-content space-between
    align-items center
    .back
        width .1rem
        height .16rem
        display block
        margin-right .17rem
        
    .help
        width .3rem
        height .3rem
        display block
    .title
        height .24rem
        font-size .17rem
        font-family PingFangSC-Medium,PingFang SC
        font-weight 500
        color rgba(255,255,255,1)
        line-height .24rem
.shade
  z-index 9
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  background rgba(0, 0, 0, .6)
.wrapper
  position fixed
  top 50%
  left 0
  right 0
  bottom 0
  z-index 10
  transform: translateY(-50%)
.shade-leave-active,.shade-enter-active
    transition: background .2s ease
.shade-enter,.shade-leave-to
    background rgba(0, 0, 0, 0)
.shade-enter-to,.shade-leave
    background rgba(0, 0, 0, .6)
</style>